import Reveal from "@/components/Reveal";

const AboutOurBrands = () => {
  return (
    <section className="bg-background py-20 sm:py-28 md:py-32">
      <div className="container mx-auto px-6">
        <Reveal className="mx-auto text-center max-w-[640px]">
          <p className="font-serif italic text-foreground/70 text-lg sm:text-xl md:text-2xl leading-relaxed mb-10 sm:mb-14">
            Botanical wisdom, tended by four generations.
          </p>

          <p className="font-sans text-[11px] tracking-[0.42em] uppercase text-accent mb-5">
            Our Worlds
          </p>
          <h2 className="font-serif text-[1.75rem] sm:text-3xl md:text-4xl text-foreground leading-[1.15] mb-6">
            A Caribbean Legacy House
          </h2>
          <p className="font-sans text-base sm:text-lg text-foreground/75 leading-relaxed">
            Sugar Town Organics is not a single brand but a house of them —
            each a chapter in a shared Caribbean philosophy of stewardship,
            wellbeing and living with intention.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default AboutOurBrands;
